<template>
  <div id="basic-textarea" ref="textarea">
    <label v-if="label" v-html="label"></label>
    <textarea
      class="textarea"
      :class="[isValid.value ? 'textareaValid' : 'textareaInvalid']"
      :rows="rows"
      :placeholder="placeholder"
      v-model="message"
    >
    </textarea>
    <transition name="fade">
      <div v-if="!isValid.value && isValid.errorMessage">
        <span class="error-text">{{ $t(isValid.errorMessage) }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BasicTextarea",
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    rows: {
      type: Number,
      required: false,
      default: 3
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    isValid: {
      type: Object,
      required: false,
      default: () => {
        return {
          value: true,
          errorMessage: ""
        };
      }
    },
    value: {
      required: false
    }
  },
  data: () => ({
    message: undefined
  }),
  created() {
    this.message = this.value;
  },
  mounted() {
    this.$refs.textarea.style.width = this.width;
  },
  computed: {},
  methods: {},
  watch: {
    value() {
      this.message = this.value;
    },
    message() {
      this.$emit("input", this.message);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#basic-textarea {
  .textarea {
    width: 100%;
    resize: none;
    border-radius: 6px;
    background: #fff;
    padding: 8px 12px;
    outline: none;
    transition: border 1s;
  }
  .textareaValid {
    border: solid 1px #adadad;
    &:focus {
      transition: box-shadow 1s;
      box-shadow: $input-shadow;
      border: 1px solid $color-primary;
    }
  }
  .textareaInvalid {
    border: 1px solid $color-danger;
    &:focus {
      transition: box-shadow 1s;
      box-shadow: $input-shadow;
      border: 1px solid $color-danger;
    }
  }
  .error-text {
    color: $color-danger;
    font-size: 11px;
    padding-left: 5px;
    font-style: italic;
  }
}
</style>
